import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/service-bg.jpg";
import { Link, useLocation } from "react-router-dom";

const AI_RPA_Support = () => {
  pageTitle("AI & RPA Support");

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper">
        <img src={aiAccounting} alt="AI Operations" className="img-fluid" />

        <div className="ai-overlay">
         <h2 className="rpa-af-title">
                  RPA SUPPORT AND MAINTENANCE
                </h2>
               
        </div>
      </div>

      
<section className="siw-rpa-support-intro">
  <div className="container">
   <ul className="siw-rpa-question-list">
  <li>
    <span className="siw-rpa-qmark">?</span>
    Have you recently completed an RPA implementation?
  </li>
  <li>
    <span className="siw-rpa-qmark">?</span>
    Are you facing challenges in maintaining and supporting your software bots?
  </li>
  <li>
    <span className="siw-rpa-qmark">?</span>
    Have you recently lost an RPA administrator or need additional support to manage expanding automation demands?
  </li>
  <li>
    <span className="siw-rpa-qmark">?</span>
    Are high-value initiatives being delayed because your team is focused on RPA administration?
  </li>
</ul>


    <p style={{marginBottom:"30px", fontSize:"20px"}}>
      With any system, maintenance is required to keep it efficient.
      Our automation specialists help manage and support your RPA environment.
    </p>

    <div className="siw-rpa-cta">
       <a href="/contact">
      <button className="siw-btn-outline">
        REQUEST RPA SUPPORT AND MAINTENANCE
      </button>
      </a>
       <a href="/contact">
      <button className="siw-btn-solid">
       
        <i className="bi bi-calendar-event"></i>
        INSTANTLY BOOK A MEETING
       
      </button>
       </a>
    </div>
  </div>
</section>
<section className="siw-rpa-services">
  <div className="container">
  <h2 className="siw-rpa-services-title">
    Our RPA Support & Maintenance Services
  </h2>

  <div className="siw-rpa-services-grid">
    <div className="siw-rpa-card">
     <div className="siw-rpa-card-title">
  <i className="fa-solid fa-gears"></i>
  <h4> Operational Support</h4>
</div>

      <ul>
        <li>Bot execution monitoring and reporting</li>
        <li>Automation environment management</li>
        <li>Monthly performance metrics and dashboards</li>
      </ul>
    </div>

    <div className="siw-rpa-card">
      <div className="siw-rpa-card-title">
  <i className="fa-solid fa-user-gear"></i>
  <h4> User Access &amp; Management</h4>
</div>

      <ul>
        <li>New user provisioning</li>
        <li>Role and permission maintenance</li>
        <li>License administration</li>
      </ul>
    </div>

    <div className="siw-rpa-card">
     <div className="siw-rpa-card-title">
  <i className="fa-solid fa-screwdriver-wrench"></i>
  <h4> RPA Support &amp; Maintenance</h4>
</div>

      <ul>
        <li>Level 1, 2, and 3 support services</li>
        <li>Access and credential management</li>
        <li>Issue resolution, troubleshooting, and debugging</li>
        <li>Process optimization and performance tuning</li>
        <li>Vendor coordination and support</li>
      </ul>
    </div>

    <div className="siw-rpa-card">
      <div className="siw-rpa-card-title">
  <i className="fa-solid fa-server"></i>
  <h4> RPA Infrastructure Management</h4>
</div>

      <ul>
        <li>Platform upgrades and patching</li>
        <li>Log monitoring and system cleanup</li>
        <li>Deployment of additional servers and components</li>
      </ul>
    </div>
  </div>
</div>

</section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_RPA_Support;
